@if (notificationsLoading()) {
  <app-loading></app-loading>
}

@if (!notificationsLoading()) {
  <div class="notifications">
    <h5>
      <fa-icon [icon]="['fas', 'flag']"></fa-icon>
      {{ "notifications.title.notifications-center" | translate }}
    </h5>
    @if (notifications().length > 0) {
      <!-- id-tracked: progress frames replace the row object, and identity
      tracking would remount app-notification on every frame -->
      @for (notification of notifications(); track notification.fingerprint_id) {
        <app-notification [notification]="notification"></app-notification>
      }
    } @else {
      <p class="no-notifications">
        {{ "notifications.message.no-notifications" | translate }}
      </p>
    }
  </div>
}
